module.exports = __webpack_public_path__ + "static/media/fremont2.107439cb.jpg";